export default "__VITE_ASSET__CQFi9EO8__"